var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-dialog",
    {
      ref: "dialog",
      attrs: {
        color: "primary",
        icon: "mdi-pause",
        "store-modal": "",
        title: _vm.generateMessage("requests.actions.pause")
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2 text-validate-btn",
                      attrs: {
                        small: "",
                        color: "primary",
                        disabled: !_vm.valid,
                        loading: _vm.isLoading
                      },
                      on: { click: _vm.pause }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.generateMessage("requests.actions.validate")
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: { small: "" },
                      on: { click: _vm.cancel }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.generateMessage("requests.actions.cancel")
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "v-form",
        { ref: "form" },
        [
          _c(
            "div",
            { staticClass: "d-flex mt-2" },
            [
              _c("v-select", {
                staticClass: "mx-2 test-select",
                attrs: {
                  "item-text": "label",
                  "item-value": "code",
                  items: _vm.items,
                  placeholder: _vm.generateMessage(
                    "requests.actions.pause_reason"
                  ),
                  color: "primary",
                  clearable: "",
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _vm.pause_reason,
                  callback: function($$v) {
                    _vm.pause_reason = $$v
                  },
                  expression: "pause_reason"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("custom-text-area", {
            staticClass: "mx-2 test-textarea",
            attrs: {
              color: "primary",
              maxCharacter: 60,
              errorTooLongMsg: "Maximum 60 caractères",
              label: _vm.generateMessage("requests.actions.comment")
            },
            model: {
              value: _vm.pause_comment,
              callback: function($$v) {
                _vm.pause_comment = $$v
              },
              expression: "pause_comment"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }